<template>
  <div id="ListMenuWeek" class="col s12 m12 xl12">
    <ul class="collapsible popout">
      <li>
        <div class="collapsible-header calendar">
          <i class="material-icons">whatshot</i>Lunes
        </div>
        <div class="collapsible-body">
          <span class="title black-text truncate">Estamos Trabajando Para Mejorar
          </span>
          </div>
      </li>
      <li>
        <div class="collapsible-header calendar">
          <i class="material-icons">whatshot</i>Martes
        </div>
        <div class="collapsible-body">
          <span class="title black-text truncate">Estamos Trabajando Para Mejorar.</span>
        </div>
      </li>
      <li>
        <div class="collapsible-header calendar">
          <i class="material-icons">whatshot</i>Miercoles
        </div>
        <div class="collapsible-body">
          <span class="title black-text truncate">Estamos Trabajando Para Mejorar</span>
        </div>
      </li>
      <li>
        <div class="collapsible-header calendar">
          <i class="material-icons">whatshot</i>Jueves
        </div>
        <div class="collapsible-body">
          <span class="title black-text truncate">Estamos Trabajando Para Mejorar</span>
        </div>
      </li>
      <li>
        <div class="collapsible-header calendar">
          <i class="material-icons">whatshot</i>Viernes
        </div>
        <div class="collapsible-body">
          <span class="title black-text truncate">Estamos Trabajando Para Mejorar</span>
        </div>
      </li>
      <li>
        <div class="collapsible-header calendar">
          <i class="material-icons">whatshot</i>Sabados
        </div>
        <div class="collapsible-body">
          <span class="title black-text truncate">Estamos Trabajando Para Mejorar</span>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "ListMenuWeek",
  data() {
    return {
      msg: "Lista de Menus de la Semana"
    };
  }
};
</script>

<style scoped lang="css">
.collapsible.popout > li.active {
  margin: 0px 0 !important;
}

.collapsible-header {
  background-color: #fff;
  border-bottom: 1px solid #ddd;
  height: 100px !important;
}

.calendar {
  background-image: url("../../assets/catering/calendar.jpg") !important;
  background-size: cover;
  filter: grayscale(20%);
}

h4 {
  text-shadow: 3px 3px 5px #f00 !important;
  font-size: 30px !important;
  color: white !important;
}
</style>


// WEBPACK FOOTER //
// src/components/menu/ListMenuWeek.vue